if (!customElements.get("shipping-location-popup")) {
  customElements.define(
    "shipping-location-popup",
    class ShippingLocationPopup extends HTMLElement {
      constructor() {
        super();
        this.cookieName = "shippingShown";
        this.euCountryCodes = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];
        this.ukStoreUrl = this.dataset.ukUrl;
        this.euStoreUrl = this.dataset.euUrl;
        this.globalStoreUrl = this.dataset.globalUrl;

        this.cacheDOMElements();
        this.init();
      }

      cacheDOMElements() {
        this.stayButton = this.querySelector("#locale-stay");
        this.countryName = this.querySelector(".user-country-name");
        this.countryRedirectTo = this.querySelector("#countryRedirectTo");
        this.countryStay = this.querySelector("#countryStay");
      }

      connectedCallback() {
        this.stayButton?.addEventListener("click", this.handleStay.bind(this));
      }

      async init() {
        if (this.getCookie(this.cookieName) === "shippingShown") return;

        await this.checkRegion();

        if (!this.isInEU()) return;

        this.updatePopupContent();
        this.showPopup();
      }

      async checkRegion() {
        try {
          const response = await fetch("/browsing_context_suggestions.json");
          const responseJson = await response.json();
          this.userLocale = responseJson?.detected_values?.country?.handle;
          this.userCountryName = responseJson?.detected_values?.country?.name;
        } catch (error) {
          console.error("Failed to fetch region data", error);
        }
      }

      isInEU() {
        return this.euCountryCodes.includes(this.userLocale);
      }

      updatePopupContent() {
        this.countryName.innerText = this.userCountryName;

        let redirectUrl = this.globalStoreUrl;
        if (this.userLocale === "GB") {
          redirectUrl = this.ukStoreUrl;
        } else if (this.isInEU()) {
          redirectUrl = this.euStoreUrl;
        }
      }

      showPopup() {
        this.classList.add("show");
      }

      handleStay() {
        this.classList.remove("show");
        document.querySelector('currency-drawer-button').click();
      }

      getCookie(cookieName) {
        const cookieString = document.cookie;
        const cookies = cookieString.split("; ");
        const cookie = cookies.find(row => row.startsWith(`${cookieName}=`));
        return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
      }
    }
  );
}
